// extracted by mini-css-extract-plugin
export default {"parentWrapper":"QuoteItem_parentWrapper__dvBsL","lrows":"QuoteItem_lrows__25v7m"};